import { render, staticRenderFns } from "./UpdateSWPrompt.vue?vue&type=template&id=6c12cc5a&"
import script from "./UpdateSWPrompt.vue?vue&type=script&lang=js&"
export * from "./UpdateSWPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports